export default __webpack_public_path__ + "static/media/signup-image.4042156c.jpg";